module.exports = __webpack_public_path__ + "static/media/MHM 2020 Virtual Video Script_1594404274750.67ac4120.pdf";